export default __webpack_public_path__ + "static/media/cedia2023.e638b6ed.jpg";